export default {
      id: "brokkoli-usage",
      viewBox: "0 0 124 68",
      url: __webpack_public_path__ + "/gfx/iconset.13.17.6.svg#brokkoli",
      toString: function () {
        return this.url;
      }
    }